import { ActionType, createAction } from 'typesafe-actions'
import { ProgramSelectOption } from './ProgramSelectOption'

export const setProgramSelectOption = createAction('SET_PROGRAM_SELECT_OPTION')<ProgramSelectOption | undefined>()

export type ProgramSelectOptionActions = ActionType<typeof setProgramSelectOption>
